const getUpdatedFilterBy = (filterBy, filterByProperty, parentData) => {
  if (!parentData || (filterBy && filterBy.length))
    return { updatedFilterBy: filterBy, updatedFilterByProperty: filterByProperty };

  const updatedFilterBy = [];
  filterByProperty.forEach(property => {
    const [key] = property.split('/');
    const filterData = parentData[key];

    if (!filterData) return;
    if (Array.isArray(filterData)) filterData.forEach(dat => updatedFilterBy.push(`${key}/${dat}`));
    else updatedFilterBy.push(`${key}/${filterData}`);
  });

  return { updatedFilterBy, updatedFilterByProperty: filterByProperty };
};

export default getUpdatedFilterBy;
